export function handleRedirection(mop, response) {
  if (response && response.result && response.result.data) {
    const { data } = response.result;
    if (data !== false) {
      if (data.redirectPspForm) {
        const formElement = document.createElement('div');
        formElement.style.display = 'none';
        formElement.innerHTML = data.redirectPspForm;
        mop.container.appendChild(formElement);
        const form = formElement.querySelector('form');
        form.submit();
        if (window.cube.config.anly_useLegacy === 'Y') {
          CUBE.Analytics.queue.send('proceedToConfirmation');
        }
      } else {
        // Change payment method
        if (data.paymentModifiable === 'false') {
          window.location.reload();
        }

        if (data.redirectConfirmation === 'true') {
          window.location.href = data.redirectionUrl;
        }

        if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
          if (mop.parent.hideLoader) {
            mop.parent.hideLoader();
          }
          mop.onExpressConfirmation(data.redirectConfirmation);
        }
      }
    } else {
      mop.parent.displayError(response.responseTO.errors[0].message);
    }
  } else {
    mop.parent.displayError(response.responseTO.errors[0].message);
  }
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-redirection.js